import React from "react";
import { SectionContainer } from "../SectionContainer/SectionContainer";
import styles from "./ElevatedSectionContainer.module.scss";
import { colors } from "@silversea-ssc/design-system-tokens";
import clsx from "clsx";
import {
  BackgroundColor,
  cssVariableForColor
} from "../Backgrounds/background";

interface ElevatedSectionContainerProps {
  dataContentName: string;
  topBackgroundColor: BackgroundColor;
  bottomBackgroundColor: BackgroundColor;
  paddingBottom?: boolean;
  className?: string;
  containerClassName?: string;
  shadow?: boolean;
  fixed?: boolean;
}

export const ElevatedSectionContainer: React.FC<
  React.PropsWithChildren<ElevatedSectionContainerProps>
> = ({
  children,
  dataContentName,
  topBackgroundColor,
  bottomBackgroundColor,
  className,
  containerClassName,
  shadow = true,
  fixed = true
}) => {
  const topColor = colors[topBackgroundColor];
  const bottomColor = colors[bottomBackgroundColor];

  const colorStyle = {
    "--top-background-color": cssVariableForColor(topColor),
    "--bottom-background-color": cssVariableForColor(bottomColor)
  } as React.CSSProperties;

  return (
    <div
      className={clsx(styles.background, className, { [styles.fixed]: fixed })}
      style={colorStyle}
      data-content-name={dataContentName}
    >
      <SectionContainer
        backgroundColor="transparent"
        className={clsx(styles.container, containerClassName, {
          [styles.withShadow]: shadow
        })}
      >
        {children}
      </SectionContainer>
    </div>
  );
};
